import { useAuth } from "@/hooks/use-auth";
import { Loader2 } from "lucide-react";
import { Route, Redirect } from "wouter";

interface ProtectedRouteProps {
  path: string;
  component: React.ComponentType;
  adminOnly?: boolean;
}

export function ProtectedRoute({
  path,
  component: Component,
  adminOnly = false,
}: ProtectedRouteProps) {
  return (
    <Route path={path}>
      {() => {
        // Make sure all hooks are called on every render
        const { user, isLoading } = useAuth();
        
        // Now handle conditionals after all hooks are called
        if (isLoading) {
          return (
            <div className="flex items-center justify-center min-h-screen">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          );
        }

        if (!user) {
          return <Redirect to="/auth" />;
        }

        if (adminOnly && user.isAdmin !== "true") {
          console.log('Access denied: User is not an admin', user);
          return <Redirect to="/" />;
        }

        return <Component />;
      }}
    </Route>
  );
}